import { useEffect, useState } from 'react';

import { SimpleValidator, SimpleValidation, Success, Fail } from '@nf/utils-common/fpw/simple-validator';
import { useBetslipStore } from '@/store/betslip';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useAccountStatus } from '@/hooks/query/account';
import { useIsBookedBetFeatureEnabled } from '@/hooks/use-is-booked-bet-feature-enabled';

export interface BookingEnableValidationData {
	accountActStatus: number;
	sport: number;
	leagueGroupId: number;
	betType: number;
	useSabaCoin: boolean;
}

const isValidAccount = SimpleValidation((x: BookingEnableValidationData) => 
	x.accountActStatus === 2
		? Success(true)
		: Fail(false)
);

const isValidSport = SimpleValidation((x: BookingEnableValidationData) => 
	x.sport === 1
		? Success(true)
		: Fail(false)
);

const isValidLeagueGroup = (leagueGroup: Array<number>) => 
	SimpleValidation((x: BookingEnableValidationData) => 
		leagueGroup.includes(x.leagueGroupId)
			? Success(true)
			: Fail(false)
	);

const isValidBetType = SimpleValidation((x: BookingEnableValidationData) => 
	[1, 3, 5, 7, 8, 413].includes(x.betType)
		? Success(true)
		: Fail(false)
);

const isValidProduct = SimpleValidation((x: BookingEnableValidationData) =>
	!x.useSabaCoin
		? Success(true)
		: Fail(false) 
);

export const useBookingButtonStatus = () => {
	const [isDisabled, setIsDisabled] = useState(false);
	const { data: actStatus } = useAccountStatus();

	const { SiteConfigsData } = useGetSiteConfigs();
	const bookedBetLeagueGroup = SiteConfigsData?.BookedBetLeagueGroup ?? [];
	
	const [
		betslipType, 
		currentMultiTickets,
		useSabaCoin,
	] = useBetslipStore(
		state => [
			state.betslipType, 
			state.currentMultiTickets,
			state.useSabaCoin
		]
	);
	const isSingleBet = betslipType === 'single';
	const singleTicket = currentMultiTickets[0];

	const isBookedBetFeatureEnabled = useIsBookedBetFeatureEnabled();
	let isBookingButtonEnabled = true;

	if (singleTicket) {
		const dataToValidate = {
			accountActStatus: actStatus ?? 0,
			sport: singleTicket.SportType,
			betType: Number(singleTicket.Bettype),
			leagueGroupId: singleTicket.LeagueGroupId,
			useSabaCoin,
		};

		// Validate various conditions
		isBookingButtonEnabled = SimpleValidator.validate(
			[
				isValidAccount, 
				isValidSport,
				isValidLeagueGroup(bookedBetLeagueGroup),
				isValidBetType,
				isValidProduct
			],
			dataToValidate
		);
	}

	useEffect(() => {
		setIsDisabled(!isBookingButtonEnabled);
	}, [isBookingButtonEnabled]);

	return {
		isVisible: isSingleBet && isBookedBetFeatureEnabled,
		isDisabled
	};
};